module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3aYvq0/tc-custom/9781625847393.jpg?1703827417209",
      "alt": "This image is the cover for the book Baseball on the Prairie"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Baseball on the Prairie\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("At the close of the nineteenth century, railroad expansion in Texas at once shrank the state and expanded opportunities, including that of Texas League Baseball. Previously, the major cities monopolized Texas minor-league ball, but with the rails came small-town teams without which the league may have floundered. Sherman, Denison, Paris, Corsicana, Cleburne, Greenville and Temple teams produced some of the Texas League's greatest players and provided unprecedented statewide interest. The 1902 Corsicana Oil Citys was one of the most successful teams of the time, claiming the second-best winning percentage and baseball's most lopsided victory, 51-3 over Texarkana's Casketmakers. In its only year in the league, Cleburne won the league championship and team owner Doak Roberts discovered the great Tris Speaker. Kris Rutherford pieces together the Texas League's early days and the people and towns that made this centuries-old institution possible.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kris Rutherford, Scott Hanzelka\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kris Rutherford is a part-time Lamar County, Texas resident who has been researching the early Texas League for nearly a decade. He is the author of Homeseekers, Parasites and the Texas Midland: The Texas League in Paris, 1896-1904, \" as well as the middle-grade sports novels \"Batting Ninth\" and \"Nothin' But Net.\"Scott Hanzelka is a baseball historian and expert on the Texas League.\"")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0